import React, { useEffect, useState } from 'react';
import { Button } from '../../../../../../base/components/Button';
import { ClickTooltip } from '../../../../../../base/components/ClickTooltip';
import { Icon } from '../../../../../../base/components/Icon';
import { useAppDispatch, useAppSelector } from '../../../../../../base/hooks';
import { isEmptyObject } from '../../../../../../base/utils';
import { __t } from '../../../../../../base/utils/t';
import { vacancyActions } from '../../../../vacancy/redux/slices/vacancySlice';
import { ErrorTooltip } from './ErrorTooltip';
import './styles.scss';
import { Loading } from '../../../../../../base/enums';

interface Props {
    vacancyId: number;
    workerId: number;
    isVacancyActive: boolean;
    markNewResponseAsReadHandler: () => void;
}

export const InviteWorkerButton = ({ vacancyId, workerId, isVacancyActive, markNewResponseAsReadHandler }: Props) => {
    const dispatch = useAppDispatch();
    const errors = useAppSelector((state) => state.vacancy.workerInvitationErrors);
    const isLoading = useAppSelector((state) => state.app.loading === Loading.WorkerInvitation);
    const [showInvitationsErrorTooltip, setShowInvitationsErrorTooltip] = useState(false);
    const [buttonWasClicked, setButtonWasClicked] = useState(false);

    useEffect(() => {
        if (errors && !isEmptyObject(errors) && errors.invitations && buttonWasClicked) {
            setShowInvitationsErrorTooltip(true);
        }

        return () => {
            if (errors) {
                dispatch(vacancyActions.setWorkerInvitationErrors(null));
            }
        };
    }, [errors, buttonWasClicked]);

    const inviteWorkerHandler = () => {
        setButtonWasClicked(true);
        markNewResponseAsReadHandler();
        dispatch(vacancyActions.inviteWorkerForVacancy(vacancyId, workerId));
    };

    const buyInvitationsHandler = () => {
        window.location.href = 'subscription/packages';
    };

    const hideInvitationsErrorTooltipHandler = () => {
        setButtonWasClicked(false);
        setShowInvitationsErrorTooltip(false);
        dispatch(vacancyActions.setWorkerInvitationErrors(null));
    };

    if (!isVacancyActive) {
        return (
            <ClickTooltip
                wrapperClassName='responses-table-invite-button__unarchive-vacancy-alert-wrap'
                className='responses-table-invite-button__unarchive-vacancy-alert-component'
                activeButton={<Button className='responses-table-invite-button'>{__t('Запросити')}</Button>}
            >
                <div className='responses-table-invite-button__unarchive-vacancy-alert-content'>
                    <Icon
                        icon='circle-info-duonote'
                        className='responses-table-invite-button__unarchive-vacancy-alert-icon'
                    />
                    {__t('Відкрийте вакансію, щоб запрошувати робітників.')}
                </div>
            </ClickTooltip>
        );
    }

    if (showInvitationsErrorTooltip) {
        return (
            <ErrorTooltip
                showTooltip={showInvitationsErrorTooltip}
                closeTooltipHandler={hideInvitationsErrorTooltipHandler}
                wrapperClassName='responses-table-invite-button__invitations-alert-wrap'
                className='responses-table-invite-button__invitations-alert-component'
                activeButton={<Button className='responses-table-invite-button'>{__t('Запросити')}</Button>}
            >
                <div className='responses-table-invite-button__invitations-alert-content'>
                    {__t(
                        'Щоб мати можливість запрошувати кандидатів на роботу та отримувати їх контактну інформацію, необхідно придбати запрошення.',
                    )}
                    <Button
                        type='secondary'
                        className='responses-table-invite-button__button-invitations'
                        onClick={buyInvitationsHandler}
                    >
                        {__t('Придбати запрошення')}
                    </Button>
                </div>
            </ErrorTooltip>
        );
    }

    return (
        <Button className='responses-table-invite-button' onClick={inviteWorkerHandler}>
            {isLoading && buttonWasClicked ? (
                <div className='responses-table-invite-button__loading-wrap'>
                    <div className='responses-table-invite-button__loading-icon'></div>
                </div>
            ) : (
                __t('Запросити')
            )}
        </Button>
    );
};
